/**
 * PilotLogin — Mi6 AIP Pilot Program early-access login page.
 *
 * Wraps the standard Login component with a top dark band reading
 * "Mi6 AIP Pilot Program — Early Access". No exclamation, no emoji.
 *
 * Route: /#/pilot/login
 */
import Login from "@/pages/Login";

export default function PilotLogin() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {/* ── Pilot early-access band ─────────────────────────────────────── */}
      <div
        style={{
          background: "#0B0B0F",
          borderBottom: "1px solid rgba(220,38,38,0.35)",
          padding: "10px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
        }}
      >
        {/* Red accent dot */}
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: "#DC2626",
            display: "inline-block",
            flexShrink: 0,
          }}
        />
        <span
          style={{
            fontSize: 11,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: "#FAFAF7",
            fontWeight: 600,
            fontFamily: "Inter, sans-serif",
          }}
        >
          Mi6 AIP Pilot Program — Early Access
        </span>
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: "#DC2626",
            display: "inline-block",
            flexShrink: 0,
          }}
        />
      </div>

      {/* ── Standard login form below the band ──────────────────────────── */}
      <div style={{ flex: 1 }}>
        <Login />
      </div>
    </div>
  );
}
